import { REFRESH_TOKEN_ENDPOINT, REFRESH_TOKEN_KEY, TOKEN_KEY } from 'app/util/consts';
import { sleep, saveCookie, getCookie, getStaticDataUrl } from 'app/util/utils';
import { isNull } from 'lodash';

class Request {

    constructor() {
        this.refreshingToken = false;
        this.appBaseApi = process.env.REACT_APP_BASE_API;
        this.appHost = process.env.REACT_APP_HOST;
    }

    get = (url, options) => this._request('GET', url, options);

    delete = (url, options) => this._request('DELETE', url, options);

    post = (url, data, options, isJson = true) => this._request('POST', url, options, data, isJson);

    put = (url, data, options, isJson = true) => this._request('PUT', url, options, data, isJson);

    getText = url => fetch(url).then(res => res.text());

    getStaticData = (fileName, subSystem) => fetch(getStaticDataUrl(fileName, subSystem)).then(res => res.json());

    async _getResponseJson(response){
        try {
            return await response.json()
        }catch (e) {
            return response.statusText
        }
    }
    
    _request(type, url, options, data, isJson) {
        options = this.getOptions(type, options, isJson);
        if (data) options.body = isJson ? JSON.stringify(data) : data;
        return new Promise(async (resolve, reject) => {
            if (url !== REFRESH_TOKEN_ENDPOINT) await this.waitForTokenOnWay();
            fetch(this.appBaseApi + '/' + url, options)
                .then(async response => {
                    if (response.status === 401) this.refreshToken(type, url, options, data, isJson, resolve, reject)
                    else if (response.status !== 200) reject({ status: response.status, details: await this._getResponseJson(response) });
                    else {
                        let json = await this._getResponseJson(response);
                        if (isNull(response.headers.get('ac-total-count'))) resolve(json)
                        else resolve({ data: json, totalCount: parseInt(response.headers.get('ac-total-count')) });
                    }
                })
                .catch(error => reject({ status: 500, details: error }));
        });
    }

    async refreshToken(type, url, options, data, isJson, resolve, reject) {
        if (url === REFRESH_TOKEN_ENDPOINT || !getCookie(REFRESH_TOKEN_KEY)) {
            if (options.redirectOn401 === false) reject({ status: 401, details:{} });
            else {
                window.location.href = this.appHost + '/auth/login';
                reject({ status: 401, details: {}  });
            }
            return;
        }
        try {
            if (this.refreshingToken) await this.waitForTokenOnWay();
            else {
                this.refreshingToken = true;
                let _data = { refreshToken: getCookie(REFRESH_TOKEN_KEY) };
                let res = await this.post(REFRESH_TOKEN_ENDPOINT, _data);
                saveCookie(TOKEN_KEY, res.accessToken, 1);
                saveCookie(REFRESH_TOKEN_KEY, res.refreshToken, 14);
                this.refreshingToken = false;
            }
            let response = await this._request(type, url, options, data, isJson);
            resolve(response);
        }
        catch (err) {
            this.refreshingToken = false;
            reject({ status: 401, details: err })
        }
    }

    async waitForTokenOnWay() {
        if (this.refreshingToken) {
            while (this.refreshingToken) {
                await sleep(100);
            }
        }
    }

    getOptions(type, options, isJson) {
        let _options = {
            headers: {
                'Accept': 'application/json',
            },
            method: type,
            redirectOn401: options?.redirectOn401
        };
        if (options?.headers) _options.headers = options.headers;
        if (options?.pagable) {
            _options.headers['ac-order'] = options.pagable.order;
            _options.headers['ac-page-number'] = options.pagable.pageNumber;
            _options.headers['ac-page-size'] = options.pagable.pageSize;
        }
        let token = getCookie(TOKEN_KEY);
        if (token) _options.headers['Authorization'] = 'Bearer ' + token;
        if (isJson) _options.headers['Content-Type'] = 'application/json';
        return _options;
    }
}

export default new Request();